var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",class:[
    `type-${_vm.type}`,
    `color-type-${_vm.colorType}`,
    `size-${_vm.size}`,
    _vm.buttonClass,
  ],style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('div',{staticClass:"button-content"},[(_vm.icon)?_c('vs-icon',{staticClass:"button-icon",attrs:{"icon-pack":"feather","icon":_vm.icon}}):_vm._e(),(_vm.label)?_c('span',{staticClass:"button-label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }